<div class="space-y-12">
  <div class="border-b border-gray-900/10 pb-2">
    <div class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
      <div class="col-span-full flex items-end gap-x-3">
        <div class="grid grid-cols-2 gap-1">
          <div>
            <label for="reviewerRole" class="primary-label">Role</label>
            <app-selection
              [ngModel]="reviewerRole"
              [options]="reviewRoles"
              (change)="changeRole($event)"
            ></app-selection>
          </div>
          <div class="place-self-center">
            @if (displayHintReviewForOtherRoleExists) {
              <span
                class="rounded-full px-2.5 py-0.5 whitespace-nowrap bg-amazone-orange text-white text-xs font-medium"
                >Review for other role active</span
              >
            }
          </div>
        </div>
        @if (canApprove) {
          <button
            [ngClass]="showCreateButton ? 'bottom-48' : 'bottom-64'"
            type="button"
            class="crud-btn-sidebar z-10"
            (click)="approveDtc()"
            appAgentAction
            agent="review-request-edit-approve"
            businessObject="reviewRequest"
            [businessId]="$safeNavigationMigration(reviewable?.id)"
            action="confirm"
          >
            <app-thumb-up-icon></app-thumb-up-icon>
          </button>
        }
      </div>
      <app-review-request-fields
        class="col-span-full"
        [item]="displayedReview"
        [editReviewEnabled]="editReviewEnabled"
        [showCreateButton]="showCreateButton"
        [createReviewDisabled]="createReviewDisabled"
        (reviewUpsertClicked)="upsertReview($event)"
        (reviewDiscardClicked)="onDiscardReview($event)"
      ></app-review-request-fields>
    </div>
  </div>
</div>

<app-decision-modal
  #discardReviewDecisionModal
  (decision)="onDiscardReviewDecision($event)"
  [header]="'Discard Review'"
  businessObject="reviewRequest"
  [details]="['This Review will be deleted. Do you want to proceed?']"
></app-decision-modal>

<app-create-review-propagation-modal #createReviewPropagationModal></app-create-review-propagation-modal>

<app-update-review-propagation-modal [executionType]="executionType.Update" #updateReviewPropagationModal>
</app-update-review-propagation-modal>

<app-delete-review-propagation-modal
  [executionType]="executionType.Delete"
  #deleteReviewPropagationModal
></app-delete-review-propagation-modal>

<app-approve-dtc-propagation-modal
  [executionType]="executionType.Approve"
  #approveSiblingsModal
></app-approve-dtc-propagation-modal>
